/*
 * Sticky Add to Cart bar (snippets/pdp-sticky-atc-rj.liquid): keeps the bar's
 * quantity stepper and the main one in step. The MAIN input is the one the
 * form submits, so a change in the bar is copied there and re-dispatched (the
 * main stepper's checks and the shipping re-quote then run as usual).
 *
 * Also places Tidio's chat bubble in the bar, and hides the wishlist under it
 * while the bubble shows (see below).
 *
 * Show/hide is CSS (assets/pdp-product.css, "pdp-sticky-atc" part), and the stepper buttons are
 * Dawn's <quantity-input> (global.js). No layout reads, no observers.
 */
(() => {
  const bar = document.querySelector('.pdp-sticky-atc[data-quantity-input]');
  if (!bar) return;

  /*
   * Tidio's chat bubble sits in the bar's right-hand slot, always (whether or
   * not the bar is showing). Done the way Tidio documents it
   * (help.tidio.com, "Widget Position"): tidioChatApi.adjustStyles() with the
   * #tidio selector, one rule per call, after Tidio's ready event. `bottom` /
   * `right` there are offsets from Tidio's own position; negative moves down/right.
   *
   * Measured Tidio layout on this site:
   *   - mouse devices: 56px bubble, 24px right / 52px bottom → down 50px so it's
   *     centred in the 60px bar; below 850px also 8px right, into the 72px slot.
   *   - phones (touch): 45px bubble, 14px right / bottom → down 6px so it's
   *     centred in the 60px bar.
   * The media features (not widths) follow Tidio's own choice of bubble, which
   * depends on the device, not the window size.
   */
  const placeTidio = () => {
    window.tidioChatApi.adjustStyles(
      '@media (hover: hover) and (pointer: fine) { #tidio { bottom: -50px !important; } }'
    );
    window.tidioChatApi.adjustStyles(
      '@media (hover: none), (pointer: coarse) { #tidio { bottom: -6px !important; } }'
    );
    window.tidioChatApi.adjustStyles(
      '@media (hover: hover) and (pointer: fine) and (max-width: 849px) { #tidio { right: -8px !important; } }'
    );
  };

  /*
   * The wishlist button shares that slot (snippets/pdp-sticky-atc-rj.liquid).
   * Tidio is only on in working hours; while its bubble shows, the bar gets
   * [data-chat-bubble] and CSS hides the wishlist under it (a square box would
   * peek out around the round bubble). Checked when Tidio is ready and on each
   * status change (online/offline), a beat later so Tidio has re-rendered.
   * Without JS, or before Tidio loads, the wishlist shows.
   */
  const syncChatBubble = () => {
    const root = document.getElementById('tidio-chat')?.shadowRoot;
    const bubble = root?.getElementById('button');
    const shown = root
      ? !!bubble && bubble.getClientRects().length > 0 && getComputedStyle(bubble).visibility !== 'hidden'
      : window.tidioChatApi?.getStatus?.() === 'online';
    bar.toggleAttribute('data-chat-bubble', shown);
  };
  const onTidioReady = () => {
    placeTidio();
    syncChatBubble();
    window.tidioChatApi.on('setStatus', () => setTimeout(syncChatBubble, 500));
  };

  if (window.tidioChatApi?.readyEventWasFired) onTidioReady();
  else if (window.tidioChatApi) window.tidioChatApi.on('ready', onTidioReady);
  else document.addEventListener('tidioChat-ready', onTidioReady, { once: true });

  const main = document.getElementById(bar.dataset.quantityInput);
  const mini = bar.querySelector('.quantity__input');
  if (!main || !mini) return;

  mini.value = main.value;

  mini.addEventListener('change', () => {
    if (main.value === mini.value) return;
    main.value = mini.value;
    main.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // The main input also changes without bubbling (reset to the minimum after an add).
  main.addEventListener('change', () => {
    if (mini.value !== main.value) mini.value = main.value;
  });
})();
